export const getToastOrderNotifications = state => state.ordersNotifications.toasted;

export const getNewOrderNotifications = state => state.ordersNotifications.findOrders;

export const getNewNotViewedOrderNotifications = state => state.ordersNotifications.notViewedFindOrders;

export const getTakenOrderNotifications = state => state.ordersNotifications.takenOrders;
